import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-panel" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = { class: "d-flex cookies-panel" }
const _hoisted_5 = { class: "d-flex justify-space-between right-content" }
const _hoisted_6 = { class: "d-flex flex-column form-content" }
const _hoisted_7 = { class: "form-checkboxs" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = { class: "form-check" }

import {ref} from 'vue'

import {useMainStore} from "@/stores/mainStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'CookiesModal',
  setup(__props) {

const data = ref<any>({terms: false, cookies: false})

const mainStore = useMainStore();

function showTerms() {
    mainStore.showTerms(true)
}

function continueHandler() {
    if (!data.value.cookies || !data.value.terms) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'You must accept cookies and terms!',
        })
        return
    }
    localStorage.setItem('cookies-accepted', 'true')
    mainStore.showCookies(false)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "content-text" }, [
            _createElementVNode("span", { class: "text-bold" }, "Mergerfilers.com provides a well-explained merger control guide and decision database. "),
            _createElementVNode("span", { class: "text" }, "It is all 100% free as the content is sponsored by some of the world's top law firms.")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "form-text" }, "To fully access those features, I accept:", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["cookies-form-check-input-outer", data.value.cookies ? 'cookies-guide-checkbox-selected' : ''])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "cookies-form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.cookies) = $event)),
                      id: "cookies"
                    }, null, 512), [
                      [_vModelCheckbox, data.value.cookies]
                    ])
                  ], 2),
                  _cache[2] || (_cache[2] = _createElementVNode("label", {
                    class: "form-check-text",
                    for: "cookies"
                  }, " Necessary cookies ", -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["cookies-form-check-input-outer", data.value.terms ? 'cookies-guide-checkbox-selected' : ''])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "cookies-form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.terms) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, data.value.terms]
                    ])
                  ], 2),
                  _createElementVNode("label", {
                    class: "form-check-text form-text-terms",
                    onClick: showTerms
                  }, " Terms of Use ")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btnstyle cookies-button align-items-center",
              onClick: continueHandler
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "button-text" }, "Continue", -1),
              _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward", -1)
            ]))])
          ])
        ])
      ])
    ])
  ]))
}
}

})